export const AMBIENT_LIGHT_CLR = 0xa87474;
export const POINT_LIGHT_CLR = "lightblue";
export const LANTERN_LIGHT_CLR = 0xfdee4b;
export const FIRE_LIGHT_CLR = "orange";
export const WINDOW_LIGHT_CLR = 0xf9ecd9;

export const AMBIENT_LIGHT_INTENSITY = 0.35;
export const POINT_LIGHT_INTENSITY = 0.45;
